export const DhunLogo = ({ size = 40, glow = true }) => (
  <img
    src="/aivigo-logo.png"
    alt="Aivigo logo"
    className="relative inline-block shrink-0 select-none"
    style={{
      width: size,
      height: size,
      filter: glow ? "drop-shadow(0 0 18px rgba(139,92,246,0.55))" : "none",
    }}
    draggable={false}
  />
);

export const DhunWordmark = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <DhunLogo size={32} glow={false} />
    <span
      className="font-extrabold tracking-tight text-white"
      style={{ fontFamily: "'Outfit', sans-serif", fontSize: 22, letterSpacing: "-0.02em" }}
    >
      Aivigo
    </span>
  </div>
);

export const AivigoFooter = ({ className = "" }) => (
  <footer className={`text-center text-xs text-slate-500 ${className}`} data-testid="aivigo-footer">
    Powered by <span className="font-bold text-slate-300">Aivigo</span> · <a href="https://aivigo.in" target="_blank" rel="noreferrer" className="text-violet-300 hover:text-white">aivigo.in</a>
  </footer>
);
